import { RefObject, useEffect } from "react";

export interface FitTextSettings {
    minFontSize?: number;
    maxFontSize?: number;
    compressor?: number;
}

export const useFitText = <T extends HTMLElement>(ref: RefObject<T | null>, settings?: FitTextSettings) => {
    useEffect(() => {
        if (window) {
            const element = ref.current;
            if (!element) return;

            settings = {
                minFontSize: parseInt(window.getComputedStyle(element.parentElement).fontSize) - 4,
                maxFontSize: parseInt(window.getComputedStyle(element.parentElement).fontSize) + 4,
                compressor: 1.5,
                ...settings,
            };

            const resize = () => {
                const charCount = element.textContent?.length || 1;

                const fontSize =
                    Math.max(
                        Math.min(
                            Math.min((element.clientWidth / charCount) * settings.compressor, element.clientHeight),
                            settings.maxFontSize
                        ),
                        settings.minFontSize
                    ) + "px";

                element.style.fontSize = fontSize;
                element.style.lineHeight = fontSize;
            };

            resize();

            element.addEventListener("resize", resize);
            return () => element.removeEventListener("resize", resize);
        }
    }, [ref]);
};
